module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-points-ledger js-points-ledger is-hidden"
  }, [_c('div', {
    staticClass: "c-points-ledger__inner"
  }, [_c('div', {
    staticClass: "c-points-ledger__header t-modal-header"
  }, [_c('h2', {
    staticClass: "c-points-ledger__header__title t-modal-header__text"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.points_ledger.modal_title')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "c-points-ledger__header__close"
  }, [_c('button', {
    staticClass: "c-points-ledger__header__close__button t-modal-header__close",
    on: {
      "click": function($event) {
        return _vm.togglePointsLedger(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "c-points-ledger__summary"
  }, [_c('div', {
    staticClass: "c-points-ledger__summary__balance"
  }, [_c('h3', {
    staticClass: "c-points-ledger__summary__balance__headline"
  }, [_vm._v(_vm._s(_vm.$t('web.points_ledger.points_balance_label')))]), _vm._v(" "), _c('p', {
    staticClass: "c-points-ledger__summary__balance__headline__number u-number-font"
  }, [_vm._v("\n          " + _vm._s(typeof _vm.participant !== 'undefined' ? _vm.formatNumber(_vm.participant.points_balance) : '') + "\n        ")])]), _vm._v(" "), (typeof _vm.participant !== 'undefined' ? _vm.participant.catalog_is_enabled : false) ? _c('div', {
    staticClass: "c-points-ledger__summary__redeem"
  }, [_c('button', {
    staticClass: "c-points-ledger__redeem-button",
    on: {
      "click": function($event) {
        return _vm.goToPage('Rewards')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.points_ledger.redeem_button')) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-points-ledger__body"
  }, [_vm._l((_vm.points.data), function(pointsRecord) {
    return _c('div', {
      key: pointsRecord.id
    }, [_c('point-record', {
      attrs: {
        "points-record": pointsRecord
      }
    })], 1)
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.points.total > 0),
      expression: "points.total > 0"
    }],
    attrs: {
      "pagination": _vm.pagination,
      "pagingCallback": _vm.paginatePoints
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "c-points-ledger__overlay"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c95b2df6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/PointsLedger.vue
// module id = 565
// module chunks = 1